/**
 * Cartão da Visão geral de uma frente (ADR 0097), como a API devolve. O id liga o número à
 * definição do cartão na tela. Cartão ausente: a pessoa não abre aquela lista.
 */
export interface HomeCardTarget {
  to: string;
  search?: Record<string, string>;
}

/**
 * Cabeçalho da empresa em foco no Dashboard executivo (ADR 0100). A tela manda só em leitura, e o
 * servidor confere se a pessoa pode.
 */
export const FOCUS_ENTITY_HEADER = 'x-loot-focus-entity';

/** `groupWide`: o número vale para o grupo todo, mesmo com uma empresa em foco. */
export type HomeCard = { groupWide?: boolean } & (
  | {
      id: string;
      state: 'ok';
      count: number;
      detail?: Record<string, number>;
      link?: HomeCardTarget;
    }
  | { id: string; state: 'ok'; inside: number; outside: number; none: number }
  | { id: string; state: 'rule_inactive'; total?: number }
  | { id: string; state: 'error' }
);

/** O que a contagem de um cartão pode dar; "error" é papel de quem lê as contagens. */
export type HomeCardValue =
  /** `link`: lista que só se conhece ao contar (a de uma versão); sem ele, vale a da definição. */
  | { count: number; detail?: Record<string, number>; link?: HomeCardTarget }
  | { inside: number; outside: number; none: number }
  | { state: 'rule_inactive'; total?: number };
